<template>
  <v-container class="pa-0">
    <v-row>
      <v-col :cols="selected === undefined ? '12' : '6'">
        <v-list>
          <v-list-item-group v-model="selected">
            <v-list-item
              v-for="viewer in viewersData"
              :key="viewer.key"
            >
              <v-list-item-title>
                {{ viewer.login }}
              </v-list-item-title>
              <v-list-item-action>
                <v-icon v-if="viewer.id_viewer == 0">mdi-account-plus</v-icon>
                <v-icon v-else>mdi-pencil</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>

      <v-col
        v-if="selected !== undefined"
        cols="6"
      >
        <v-tabs
          v-model="activeTab"
          fixed-tabs
          show-arrows
        >
          <v-tab>
            <v-icon left>mdi-account</v-icon>
            {{ $t("profile.tabs.general") }}
          </v-tab>
          <v-tab>
            <v-icon left>mdi-monitor-screenshot</v-icon>
            {{ $t("profile.tabs.screens") }}
          </v-tab>
          <v-tab-item class="mt-4">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="viewersData[selected].login"
                    :label="$t('profile.sections.user.login')"
                    :rules="[rules.required, rules.regex]"
                    append-icon="email"
                    type="email"
                    dense
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="viewersData[selected].password"
                    :append-icon="show ? 'visibility' : 'visibility_off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    :label="$t('profile.sections.user.password')"
                    :hint="this.$t('field.min-8')"
                    counter
                    dense
                    @click:append="show = !show"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="viewersData[selected].name"
                    :rules="[rules.required]"
                    :label="$t('profile.sections.common.name')"
                    dense
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="viewersData[selected].firstname"
                    :rules="[rules.required]"
                    :label="$t('profile.sections.user.firstname')"
                    dense
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="viewersData[selected].notif"
                    :label="$t('profile.sections.viewer.notification')"
                    dens
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="search"
                    :label="$t('schedule.player-search')"
                    single-line
                    hide-details
                    append-icon="mdi-magnify"
                    clearable
                  />
                  <v-treeview
                    v-model="viewersData[selected].players_visible"
                    :items="playersItem"
                    :search="search"
                    selectable
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <v-row v-if="viewersData[selected].id_viewer == 0">
          <v-col cols="12">
            <v-btn
              color="success"
              :disabled="viewersData[selected].login.length < 6 || viewersData[selected].password.length < 8"
              @click="createViewer()"
            >
              <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.create") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="6">
            <v-btn
              color="primary"
              :disabled="
                viewersData[selected].login.length < 6 || viewersData[selected].password.length < 8 || disableButton
              "
              @click="updateViewerData(viewersData[selected].id_viewer)"
            >
              <v-icon class="mr-2">mdi-content-save-outline</v-icon>{{ $t("profile.sections.common.update") }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <button-dialog-delete
              :text="$t('popup.user')"
              :is-button-disabled="viewersData.length <= 2"
              @ok-pushed="disableViewer(viewersData[selected].id_viewer)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-message
      :open="dialogOpen"
      :header="dialogHeader"
      :content="dialogContent"
      @close-pushed="dialogOpen = false"
    />
  </v-container>
</template>

<script>
// Components
import buttonDialogDelete from "../Common/ButtonDialogDelete";
import dialogMessage from "../Common/DialogMessage";

// Connectors
import { PlayerConnector } from "../Database/PlayerConnector";
import { ProfileViewerConnector } from "../Database/ProfileViewerConnector.js";

export default {
  components: {
    buttonDialogDelete,
    dialogMessage,
  },
  data() {
    return {
      playerConnector: new PlayerConnector(this.$store.state.user),
      viewerConnector: new ProfileViewerConnector(this.$store.state.user),
      selected: undefined,
      disableButton: false,
      viewersData: [],
      playersItem: [],
      search: "",
      show: false,
      rules: {
        required: (value) => !!value || this.$t("field.required"),
        min: (v) => v.length >= 8 || this.$t("field.min-8"),
        regex: (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t("profile.sections.user.mail"),
      },
      dialogOpen: false,
      dialogHeader: "",
      dialogContent: "",
      dialogType: "",
      activeTab: null,
    };
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.getViewersData();
      this.getAllPlayersIdName();
    }
  },
  methods: {
    getViewersData() {
      this.viewerConnector
        .getViewersData()
        .then((viewers) => {
          // TODO: format in db server
          this.viewersData = viewers.map((data) => {
            return {
              id_viewer: data.id_viewer,
              login: data.login,
              password: "",
              name: data.lastname,
              firstname: data.firstname,
              players_visible: data.players_visible.split("|").map((player) => {
                return parseInt(player);
              }),
              notif: data.notif,
            };
          });

          this.viewersData.unshift({
            id_viewer: 0,
            login: this.$t("profile.sections.viewer.new"),
            password: "",
            name: "",
            firstname: "",
            players_visible: [],
            notif: "1",
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAllPlayersIdName() {
      this.playerConnector
        .getAllPlayersIdName()
        .then((players) => {
          this.playersItem = players;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    createViewer() {
      if (this.viewersData[this.selected].login.length >= 6 && this.viewersData[this.selected].password.length >= 8) {
        this.disableButton = true;

        this.viewerConnector
          .insertViewerData(this.viewersData[this.selected])
          .then(() => {
            this.getViewersData();
            this.viewersData[this.selected].password = "";
          })
          .catch((err) => {
            this.dialogOpen = true;
            this.dialogHeader = this.$t("dialog.warning");
            this.dialogContent = this.$t("error.create");
            this.dialogType = "warning";
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    updateViewerData(vid) {
      if (this.viewersData[this.selected].login.length >= 6 && this.viewersData[this.selected].password.length >= 8) {
        this.disableButton = true;

        this.viewerConnector
          .updateViewerData(this.viewersData[this.selected], vid)
          .then(() => {
            this.viewersData[this.selected].password = "";
          })
          .catch((err) => {
            this.dialogOpen = true;
            this.dialogHeader = this.$t("dialog.warning");
            this.dialogContent = this.$t("error.update");
            this.dialogType = "warning";
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
    disableViewer(vid) {
      if (vid > 0) {
        this.viewerConnector
          .disableViewerData(vid)
          .then(() => {
            this.viewersData.splice(this.selected, 1);
            this.selected = undefined;
          })
          .catch((err) => {
            this.dialogOpen = true;
            this.dialogHeader = this.$t("dialog.warning");
            this.dialogContent = this.$t("error.delete");
            this.dialogType = "warning";
            console.error(err);
          })
          .finally(() => {
            this.disableButton = false;
          });
      }
    },
  },
};
</script>

<style></style>
